import { MEDIAS } from "@/packages/theme/tokens";
import { useGetCommon, type AttractionResponse } from "@/shared/server";
import { FONT } from "@/styles";
import { Box, Center, chakra, Flex, Spinner, Text } from "@chakra-ui/react";
import DOMPurify from "dompurify";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { type TravelProps } from "./travel.type";

export const Travel = ({ data }: TravelProps) => {
    const { data: travelData } = useGetCommon<AttractionResponse>({ section: "travels" });
    const { ref, inView } = useInView({ threshold: 0.7, delay: 1, triggerOnce: true });

    const { isMobile, isLaptop } = MEDIAS();

    return travelData || data ? (
        <Center ref={ref} position="relative" w="100%" background="#fbf6f2">
            <Center as="section" p={isMobile ? "56px 0" : "120px 0"} justifyContent="flex-end">
                <Flex
                    p={isMobile ? "0" : "0 0 0 48px"}
                    gap={isMobile ? "16px" : "32px"}
                    maxW="1760px !important"
                    w="100%"
                    flexDir={isMobile ? "column" : "row"}
                >
                    <Flex
                        flexDir="column"
                        justifyContent={isMobile ? "normal" : "space-between"}
                        gap={isMobile ? "16px" : "0"}
                    >
                        <Box h={isMobile ? "auto" : "264px"} p={isMobile ? "0 16px" : "0"}>
                            <Flex flexDir="column" gap="8px">
                                <Text {...FONT("notoSerif", isMobile ? 14 : 24, 600, 1.4)}>
                                    다양한 주변관광지와 함께하는 휴식
                                </Text>
                                <Text {...FONT("notoSerif", isMobile ? 20 : 40, 600, 1.4)}>AROUND PENSION</Text>
                            </Flex>
                            <Box
                                mt={isMobile ? "16px" : "24px"}
                                sx={{
                                    "& p": {
                                        ...FONT("pretendard", 16, 300, 1.4),
                                        color: "#6b6b6b",
                                    },
                                }}
                            >
                                {data ? (
                                    <Text dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data.intro) }}></Text>
                                ) : (
                                    <>
                                        <Text>다양한 즐길거리와 볼거리가 가득한 펜션명에서</Text>
                                        <Text>사랑하는 가족,연인,친구들과 평생</Text>
                                        <Text>잊지못할 추억을 만들어 보세요.</Text>
                                    </>
                                )}
                            </Box>
                        </Box>
                        <Flex justifyContent="flex-end" pl={isMobile ? "16px" : "0"}>
                            <MotionFirstImg
                                maxW={isMobile ? "none" : "348px"}
                                w="100%"
                                h={isMobile ? "256px" : "296px"}
                                background={
                                    data?.imgList[0]
                                        ? `url(${data.imgList[0].img_URL})no-repeat center/cover`
                                        : `url(${travelData?.imgList[0].imgUrl})no-repeat center/cover`
                                }
                                animate={{
                                    // eslint-disable-next-line no-nested-ternary
                                    borderTopLeftRadius: inView ? (isMobile ? "40px" : "88px") : "0px",
                                }}
                            ></MotionFirstImg>
                        </Flex>
                    </Flex>
                    <Box maxW="604px" w="100%" pr={isMobile ? "16px" : "0"}>
                        <MotionSecondImg
                            w="100%"
                            h={isMobile ? "256px" : "796px"}
                            background={
                                data?.imgList[1]
                                    ? `url(${data.imgList[1].img_URL})no-repeat center/cover`
                                    : `url(${travelData?.imgList[1].imgUrl})no-repeat center/cover`
                            }
                            animate={{
                                // eslint-disable-next-line no-nested-ternary
                                borderTopRightRadius: inView ? (isMobile ? "40px" : "88px") : "0px",
                            }}
                        />
                    </Box>
                    <Flex display={isLaptop ? "none" : "flex"} maxW="520px" w="100%" alignItems="flex-end" pb="104px">
                        <MotionThirdmg
                            w="100%"
                            h="386px"
                            background={
                                data?.imgList[2]
                                    ? `url(${data.imgList[2].img_URL})no-repeat center/cover`
                                    : `url(${travelData?.imgList[2].imgUrl})no-repeat center/cover`
                            }
                            animate={{
                                borderBottomLeftRadius: inView ? "88px" : "0",
                            }}
                        />
                    </Flex>
                </Flex>
            </Center>
        </Center>
    ) : (
        <Center h="100vh" columnGap="8px">
            <Text>LOADING</Text>
            <Spinner />
        </Center>
    );
};

const MotionFirstImg = chakra(motion.div);
const MotionSecondImg = chakra(motion.div);
const MotionThirdmg = chakra(motion.div);
